export default {
    'gb': {
        'content': {
            'GlobalJobArchitecturePage': 'Global job architecture page',
            'FunctionalAreaPage': 'Functional area page',
            'SimplePage': 'Simple page',
            'JobPage': 'Job page',
            'FindOutMorePage': 'Find out more page',
            "OnlyBecauseYouAreWorkingWithUsPage": "Only because you are working with us page",
            "PicturePage": "Picture page",
            "TextPage": "Text page",
            "UsefulToolsPage": "Useful tools page",
            "AnonymousReportingPage": "Anonymous reporting page",
            "SlideshowPage": "Slideshow page",
            "NewsPage": "News listing page",
            "StandardPage": "Standard page",
            "LearnerHomePage": "Learner home page",
            "NewsArticle": "News page",
            "InfoBoxWidget": "Info box widget",
            "EmailAdministrationWidget": "E-mail administration widget"
        },
        'block': {
            'FunctionalAreaBlock': 'Functional area block',
            'TableBlock': 'Table block',
            'TableBlockItem': 'Table block item',
            'LevelDescription': 'Level description',
            'SliderBlockItem': 'Slider block item',
            'AccordionItem': 'Accordion item',
            "SliderBlock": "Slider block",
            "LinkBlock": "Link block",
            "IconBlock": "Icon block",
            "IconLinkBlock": "Icon link block",
            "NewsTeaserBlock": "News Teaser Block",
            "TasksBlock": "Important dates Block",
            "BirthdayBlock": "Birthday Block",
            "HighScoreBlock": "Leaderboard Block",
            "FaqBlock": "FAQ Block",
            "VideoBlock": "Video Block",
            "TimetrackerBlock": "Timetracker Block",
            "FormBlock": "Form Block",
            "ContactsBlock": "Contacts Block",
            "OnboardingBlock": "Onboarding Block",
            "FaqBlockItem": "FAQ Block Item",
            "TaskBlockItem": "Important dates Item",
            "CsodTasksBlock": "Task Block",
            "ClickableTilesBlock": "Clickable Card Block",
            "ClickableTilesBlockItem": "Clickable Card Block Item",
            "HelpBlock": "Help Block",
            "HelpBlockItem": "Help Block Item",
            "Hero": "Hero Block",
            "HeroSmall": "Help Small Block",
            "CarouselBlock": "Carousel Block",
            "CarouselBlockItem": "Carousel Block Item",
            "LearnerHomeMaterialBlock": "Learner Home Material Block",
            "HeaderBlock": "Header Block",
            "LearnerHomeUserInfoBlock": "Learner Home User Info Block",
            "CornerstoneWidgetBlock": "Cornerstone Widget Block (Card)",
            "SpaceBlock": "Space Block",
            "LearnerHomeWidgetBlock": "Cornerstone Widget Block (Carousel)",
            "ExpireDate": "Expiry Date"
        },
        'field': {
            'BlockArea': 'Blocks',
            'FrontImage': 'Front image',
            'PdfFile': 'PDF file',
            'PageLink': 'Page link',
            'FunnyPageLink': 'Funny page link',
            'Names': 'Names',
            'YouTubeClip': 'Youtube',
            'AreasHeadline': 'Areas headline',
            'AreaBlocks': 'Area blocks',
            'TopImage': 'Top image',
            'TopImageTitle': 'Top image title',
            'TopImageSubTitle': 'Top image sub title',
            '5adLink': '5a-d link',
            '4bLink': '4b link',
            '4aLink': '4a link',
            '3bLink': '3b link',
            '3aLink': '3a link',
            '2bLink': '2b link',
            '2aLink': '2a link',
            '1cLink': '1c link',
            'TableBlock': 'Table block',
            'LevelDescBlock': 'Level description block',
            'JobExamples': 'Job examples',
            'TypicalExperience': 'Typical experience',
            'JobAreaTitle': 'Job area title',
            'SliderBlockArea': 'Slider block area',
            'Call2ActionImage': 'Call 2 action - image',
            'Call2ActionTitle': 'Call 2 action - title',
            'Call2ActionSlider': 'Call 2 action - slider',
            'VisibleCall2Action': 'Visible call 2 action',
            'Body1': 'Body 1',
            'Body2': 'Body 2',
            'Body3': 'Body 3',
            'CircleImage': 'Circle image',
            'CircleTitle1': 'Circle title 1',
            'CircleTooltip1': 'Circle tooltip 1',
            'CircleTitle2': 'Circle title 2',
            'CircleTooltip2': 'Circle tooltip 3',
            'CircleTitle3': 'Circle title 3',
            'CircleTooltip3': 'Circle tooltip 3',
            'CircleTitle4': 'Circle title 4',
            'CircleTooltip4': 'Circle tooltip 4',
            'CircleTitle5': 'Circle title 5',
            'CircleTooltip5': 'Circle tooltip 5',
            'CircleTitle6': 'Circle title 6',
            'CircleTooltip6': 'Circle tooltip 6',
            'CircleTitle7': 'Circle title 7',
            'CircleTooltip7': 'Circle tooltip 7',
            'BackgroundImage': 'Background image',
            'DisplayCount': 'Display count',
            'PaginateEnabled': 'Paginate enabled',
            'SortOrder': 'Sort order',
            'ListingAttributes': 'Listing attributes',
            "HeroLearnerHome": "Hero - Learner home",
            "ExpireDate": "Expiry Date",
            "ContactUs": "Contact us",
            "DataTag": "Data tag"
        },
        'help': {
            'field': {}
        }
    },
    'sv': {
        'content': {
            'GlobalJobArchitecturePage': 'Global job architecture page',
            'FunctionalAreaPage': 'Functional area page',
            'SimplePage': 'Simple page',
            'JobPage': 'Job page',
            'FindOutMorePage': 'Find out more page',
            "OnlyBecauseYouAreWorkingWithUsPage": "Only because you are working with us page",
            "PicturePage": "Picture page",
            "TextPage": "Text page",
            "UsefulToolsPage": "Useful tools page",
            "AnonymousReportingPage": "Anonymous reporting page",
            "SlideshowPage": "Slideshow page",
            "NewsPage": "News listing page",
            "StandardPage": "Standard page",
            "LearnerHomePage": "Learner home page",
            "NewsArticle": "News page",
            "InfoBoxWidget": "Info box widget",
            "EmailAdministrationWidget": "E-mail administration widget"
        },
        'block': {
            'FunctionalAreaBlock': 'Functional area block',
            'TableBlock': 'Table block',
            'TableBlockItem': 'Table block item',
            'LevelDescription': 'Level description',
            'SliderBlockItem': 'Slider block item',
            'AccordionItem': 'Accordion item',
            "SliderBlock": "Slider block",
            "LinkBlock": "Link block",
            "IconBlock": "Icon block",
            "IconLinkBlock": "Icon link block",
            "NewsTeaserBlock": "News Teaser Block",
            "TasksBlock": "Important dates Block",
            "BirthdayBlock": "Birthday Block",
            "HighScoreBlock": "Leaderboard Block",
            "FaqBlock": "FAQ Block",
            "VideoBlock": "Video Block",
            "TimetrackerBlock": "Timetracker Block",
            "FormBlock": "Form Block",
            "ContactsBlock": "Contacts Block",
            "OnboardingBlock": "Onboarding Block",
            "FaqBlockItem": "FAQ Block Item",
            "TaskBlockItem": "Important dates Item",
            "CsodTasksBlock": "Task Block",
            "ClickableTilesBlock": "Clickable Card Block",
            "ClickableTilesBlockItem": "Clickable Card Block Item",
            "HelpBlock": "Help Block",
            "HelpBlockItem": "Help Block Item",
            "Hero": "Hero Block",
            "HeroSmall": "Help Small Block",
            "CornerstoneWidgetBlock": "Cornerstone Widget Block (Card)",
            "SpaceBlock": "Space Block",
            "LearnerHomeWidgetBlock": "Cornerstone Widget Block (Carousel)"
        },
        'field': {
            'BlockArea': 'Blocks',
            'FrontImage': 'Front image',
            'PdfFile': 'PDF file',
            'PageLink': 'Page link',
            'FunnyPageLink': 'Funny page link',
            'Names': 'Names',
            'YouTubeClip': 'Youtube',
            'AreasHeadline': 'Areas headline',
            'AreaBlocks': 'Area blocks',
            'TopImage': 'Top image',
            'TopImageTitle': 'Top image title',
            'TopImageSubTitle': 'Top image sub title',
            '5adLink': '5a-d link',
            '4bLink': '4b link',
            '4aLink': '4a link',
            '3bLink': '3b link',
            '3aLink': '3a link',
            '2bLink': '2b link',
            '2aLink': '2a link',
            '1cLink': '1c link',
            'TableBlock': 'Table block',
            'LevelDescBlock': 'Level description block',
            'JobExamples': 'Job examples',
            'TypicalExperience': 'Typical experience',
            'JobAreaTitle': 'Job area title',
            'SliderBlockArea': 'Slider block area',
            'Call2ActionImage': 'Call 2 action - image',
            'Call2ActionTitle': 'Call 2 action - title',
            'Call2ActionSlider': 'Call 2 action - slider',
            'VisibleCall2Action': 'Visible call 2 action',
            'Body1': 'Body 1',
            'Body2': 'Body 2',
            'Body3': 'Body 3',
            'CircleImage': 'Circle image',
            'CircleTitle1': 'Circle title 1',
            'CircleTooltip1': 'Circle tooltip 1',
            'CircleTitle2': 'Circle title 2',
            'CircleTooltip2': 'Circle tooltip 3',
            'CircleTitle3': 'Circle title 3',
            'CircleTooltip3': 'Circle tooltip 3',
            'CircleTitle4': 'Circle title 4',
            'CircleTooltip4': 'Circle tooltip 4',
            'CircleTitle5': 'Circle title 5',
            'CircleTooltip5': 'Circle tooltip 5',
            'CircleTitle6': 'Circle title 6',
            'CircleTooltip6': 'Circle tooltip 6',
            'CircleTitle7': 'Circle title 7',
            'CircleTooltip7': 'Circle tooltip 7',
            'BackgroundImage': 'Background image',
            'DisplayCount': 'Display count',
            'PaginateEnabled': 'Paginate enabled',
            'SortOrder': 'Sort order',
            'ListingAttributes': 'Listing attributes',
            "HeroLearnerHome": "Hero - Learner home",
            "ContactUs": "Contact us",
            "DataTag": "Data tag"
        },
        'help': {
            'field': {}
        }
    },
};



// WEBPACK FOOTER //
// ./src/core/admin/config/translations.js